import React from 'react'

const Test = () => {
    return (
        <div>
            <h1 className='ml-5'>404</h1>
        </div>
    )
}

export default Test 
